
import { Component, Vue } from 'vue-property-decorator';

const OPTION_LIST = [
  {
    title: '排序',
    dataIndex: 'sort',
    align: 'center',
    scopedSlots: { customRender: 'sort' },
  },
  {
    title: '品类',
    align: 'center',
    dataIndex: 'name',
  },
  {
    title: '操作',
    align: 'center',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/boss/ruan/category`,
  sort: `${FCAPI}/boss/ruan/category/sort`,
};
@Component
export default class Product extends Vue {
  columns = OPTION_LIST;
  data_source = [];
  is_show = false;
  is_loading = false;
  add_name = '';
  delete_id = 0;
  is_show_add = false;
  edit_sort = 0;
  form = {
    error: '',
    status: '',
  };
  created() {
    this.query();
  }
  // 请求列表数据
  async query() {
    this.is_loading = true;
    const { data } = await this.$axios.get(API.query);
    if (data.status !== 200) {
      this.is_loading = false;
      return;
    }
    this.is_loading = false;
    this.data_source = data.data;
  }
  // 显示添加品类弹框
  showAddModal() {
    this.is_show_add = true;
  }
  // 提交添加请求
  async handleSubmitAdd() {
    // 验证风格名称是否填写
    const flag = this.validatorStyleName(this.add_name);
    // 验证风格名称是否填写
    if (!flag) {
      return;
    }
    const { data } = await this.$axios.post(API.query, { name: this.add_name });
    if (data.status !== 200) {
      return this.$message.error(data.message);
    }
    this.is_show_add = false;
    this.$message.success('添加成功');
    this.add_name = '';
    this.query();
  }
  // 处理删除事件
  handleDelete(data: any) {
    this.is_show = true;
    this.delete_id = data.id;
  }
  // 处理编辑排序
  handleSortInput(e: any) {
    this.edit_sort = parseInt(e.data);
  }
  // 提交排序
  async submitSortEdit(item_data: any) {
    // 判断排序值是否发生改变或者是否为空
    if (item_data.sort !== this.edit_sort && this.edit_sort) {
      const { data } = await this.$axios.put(`${API.sort}/${item_data.id}`, {
        id: item_data.id,
        sort: this.edit_sort,
      });
      if (data.status !== 200) return;
      this.$message.success('编辑成功');
      this.query();
    }
  }
  // 确认删除
  async submitDelete() {
    this.is_show = false;
    const { data } = await this.$axios.delete(`${API.query}/${this.delete_id}`);
    if (data.status !== 200) return;
    this.$message.success('删除成功');
    this.query();
  }
  // 取消弹框
  handleCancel() {
    this.is_show = false;
    this.is_show_add = false;
    this.add_name = '';
    this.form.status = '';
    this.form.error = '';
  }
  // 验证风格名字是否填写
  validatorStyleName(style_name: string) {
    if (style_name !== '') {
      this.form.status = '';
      this.form.error = '';
      return true;
    }
    this.form.status = 'error';
    this.form.error = '请填写品类名称';
    return false;
  }
}
